import StaticPage from "@/pages/StaticPage";
export default function Nacimiento() { return <StaticPage slug="nacimiento" />; }
